import { Gift } from '../../models/Gift'
import { WorkflowPage } from '../workflows/WorkflowPage'

type Props = {
    gift: Gift
}

export const NewGiftCompletePage = ({ gift }: Props) => {
    const { onReset } = WorkflowPage.useResetContainerContext()

    return (
        <div className="flex items-center justify-center">
            <div className="max-w-xlarge mt-12">
                <WorkflowPage.SuccessView
                    subtitle={
                        gift.client !== undefined
                            ? `The gift certificate for ${gift.client.name} was saved`
                            : 'The gift certificate was saved'
                    }
                    links={[
                        {
                            id: 'create-another',
                            onClick: onReset,
                            title: 'Create another',
                            subtitle: 'Sell new gift certificate',
                            icon: 'plus.large',
                        },
                        {
                            id: 'view',
                            to: `/gifts/${gift.id}`,
                            title: 'View gift certificate',
                            subtitle: 'View this gift certificate',
                            icon: 'gift.large',
                        },
                        {
                            id: 'calendar',
                            to: '/calendar',
                            title: 'Calendar',
                            subtitle: 'View your calendar',
                            icon: 'calendar.large',
                        },
                        {
                            id: 'dashboard',
                            to: '/',
                            title: 'Dashboard',
                            subtitle: 'View home screen',
                            icon: 'home.large',
                        },
                    ]}
                />
            </div>
        </div>
    )
}
